import http from './http';

export default {
  validate(params) {
    return http.get('/validate', {
      params,
    });
  },
};
